<div class="d-felx">

  <div class="card">
    <div data-toggle="collapse" class="pointer" data-target="#creditOfferDiv" role="button" aria-expanded="false"
         aria-controls="creditOfferDiv" aria-hidden="true">
      <h4 class="card-header accordion-up">
        Offer Confirmation<span class="pull-right mr-3">
          <i class="fa icon-info" aria-hidden="true">
          </i>
        </span>
      </h4>
    </div>
  </div>

  <div class="col md-12 clearfix py-3">
    <div class="card" id="creditHolderParent">
      <div id=" creditOfferDiv" class="collapse show">
        <div class="card-body">
          <div class="text-success" *ngIf="offerNumber!=null && offerNumber!=''">
            <p>Thank you! Offer <b>{{offerNumber}}</b> submitted successfully. You will receive a confirmation email shortly.</p>
          </div>
          <div class="text-danger" *ngIf="offerNumber==null || offerNumber==''">
            <p><strong>Invalid offer.</strong></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
